import style from "./Header.css";

import { BiSearchAlt2 } from "react-icons/bi";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaUserCircle } from "react-icons/fa";
import { useEffect, useState, useCallback, useRef } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { IoClose } from "react-icons/io5";

import { CommonAxios } from "../CommonAxios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BiMenu } from "react-icons/bi";
import { FiFacebook } from "react-icons/fi";
import { AiOutlineInstagram, AiOutlineTwitter } from "react-icons/ai";
import { localeData } from "moment";
import { icons } from "react-icons";
import logo from "../../assets/images/logo.png";
import pro from "../../assets/images/profile_img.png";
import icon1 from "../../assets/images/g693.png";
import icon2 from "../../assets/images/g681.png";
import icon3 from "../../assets/images/g715.png";
import icon4 from "../../assets/images/g727.png";
import icon5 from "../../assets/images/g720.png";
import icon6 from "../../assets/images/g745.png";
import icon7 from "../../assets/images/g738.png";
import icon8 from "../../assets/images/g733.png";
import icon9 from "../../assets/images/notice.png";
import icon10 from "../../assets/images/qna.png";
import icon11 from "../../assets/images/talk.png";
import ChannelService from "../../ChannelService";
const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [locationData, setLocationData] = useState("");
  const [moreView, setMoreView] = useState(false);
  const slickRef = useRef(null);
  useEffect(() => {
    ChannelService.loadScript();

    //3. 부트하기
    ChannelService.boot({
      pluginKey: "d5c3dd7d-f725-4c12-97cb-f593028eb153",
    });
  }, []);

  // const previous = useCallback(() => slickRef.current.slickPrev(), []);
  // const next = useCallback(() => slickRef.current.slickNext(), []);
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 10,
    slidesToScroll: 10,
    initialSlide: 0,
    // afterChange: (current) => {
    //   setState(current + 1);
    // },
    dotsClass: `header_custom_class_name`,
    responsive: [
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          initialSlide: 0,
          rows: 2,
          // slidesPerRow: 2,
        },
      },
    ],

    // arrows: ,
    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />,
  };
  const [state, setState] = useState(1);
  useEffect(() => {
    setMoreView(false);
    setLocationData(location.pathname);
  }, [location]);
  const { user } = useSelector(({ user }) => ({
    user: user.user,
  }));
  const keyEvent = (e) => {
    if (searchValue === "") return;
    if (e.key === "Enter") {
      navigate(`/search?keyword=${searchValue}`);
      setSearchValue("");
    }
  };
  const btn_logout = () => {
    let sendData = "";
    CommonAxios(
      process.env.REACT_APP_HOSTDONAME + "/api/signout",
      sendData,
      function (result) {
        if (result.messageinfo.state === "ok") {
          localStorage.removeItem("digibooktoken");
          document.location.href = "/";
        } else {
          //   alert(result.messageinfo.message);
        }
      }
    );
  };
  const searchBtn = () => {
    if (searchValue === "") return;

    navigate(`/search?keyword=${searchValue}`);
    setSearchValue("");
  };
  const [searchValue, setSearchValue] = useState("");
  const LoginIcon = () => {
    return (
      <>
        <div className="header-login-icon-wrap">
          <Link to="/mypage">
            <div className="header-login-icon">
              <img src={user.ur_image !== "" ? user.ur_image : ""} />
            </div>
          </Link>
        </div>{" "}
      </>
    );
  };
  const changeSearch = useCallback((e) => {
    setSearchValue(e.target.value);
  }, []);
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const handleResize = () => {
    setWindowSize(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  const move = () => {
    navigate("/mypage");
  };
  const move1 = () => {
    navigate("/login");
  };
  const move2 = () => {
    navigate("/SignUp");
  };
  const move3 = () => {
    navigate("/admin/users");
  };

  const [menu, setMenu] = useState(false);
  const menu_click = () => {
    setMenu(!menu);
  };

  useEffect(() => {
    if (menu) {
      document.body.style = `overflow: hidden`;
      return () => (document.body.style = `overflow: auto`);
    }
  }, [menu]);
  return (
    <>
      <div
        className={
          menu ? "header_right_wrap_d div_block" : "header_right_wrap_d"
        }
      >
        {" "}
        <div
          className="header_right_wrap"
          onClick={() => {
            menu_click();
          }}
        ></div>
        <div className="hd_right_menu_wrap">
          <div className="hd_right_menu_close_box">
            <div className="hd_right_menu_close_box_inner">
              <div>
                <button
                  onClick={() => {
                    menu_click();
                  }}
                >
                  <IoClose />{" "}
                </button>
              </div>
            </div>
          </div>
          <div className="hd_right_menu_inner">
            <div className="hd_right_menu_top">
              <div className="hd_right_menu_img">
                <img src={pro} />
              </div>{" "}
              <div className="hd_right_menu_info">
                <div className="hd_info_one">
                  <div className="hd_info_one_left">
                    <span className="hd_info_name">{user.ur_name} </span>
                    <span className="hd_info_id">{user.ur_}</span>
                  </div>
                  <div className="hd_info_one_right">
                    <button onClick={btn_logout}>로그아웃</button>
                  </div>
                </div>{" "}
                <div className="hd_info_two">
                  <div className="hd_info_two_left">
                    <span className="hd_info_title">학년</span>
                  </div>
                  <div className="hd_info_two_right">
                    <span>
                      {user.ur_grade === 0 && "관리자계정"}
                      {user.ur_grade !== 0 && user.ur_grade}학년
                    </span>
                  </div>
                </div>{" "}
                <div className="hd_info_three">
                  <div className="hd_info_three_left">
                    <span className="hd_info_title">D-00</span>
                  </div>
                  <div className="hd_info_two_right">
                    <span>2023.09.20 ~ </span>
                  </div>
                </div>{" "}
              </div>
            </div>
            <div className="hd_right_menu_middle">
              <ul>
                {/* <li className="middle_menu_li">
                  <Link to="">
                    <div className="middle_menu_div">
                      <img src={icon1} />
                      <span>구매 내역</span>
                    </div>
                  </Link>
                </li>
                <li className="middle_menu_li">
                  <Link to="">
                    <div className="middle_menu_div">
                      <img src={icon2} />
                      <span>장바구니·배송</span>
                    </div>
                  </Link>
                </li>
                <li className="middle_menu_li">
                  <Link to="">
                    <div className="middle_menu_div">
                      <img src={icon3} />
                      <span>쪽지함</span>
                    </div>
                  </Link>
                </li>
                <li className="middle_menu_li">
                  <Link to="">
                    <div className="middle_menu_div">
                      <img src={icon4} />
                      <span>쿠폰함</span>
                    </div>
                  </Link>
                </li>
                <li className="middle_menu_li">
                  <Link to="">
                    <div className="middle_menu_div">
                      <img src={icon5} />
                      <span>이벤트 바로가기</span>
                    </div>
                  </Link>
                </li>
                <li className="middle_menu_li">
                  <Link to="">
                    <div className="middle_menu_div">
                      <img src={icon6} />
                      <span>이벤트 참여내역</span>
                    </div>
                  </Link>
                </li> */}
                <li className="middle_menu_li">
                  <Link to="/info" onClick={() => menu_click()}>
                    <div className="middle_menu_div">
                      <img src={icon7} />
                      <span>회원정보 수정</span>
                    </div>
                  </Link>
                </li>
                {/* <li className="middle_menu_li">
                  <Link to="">
                    <div className="middle_menu_div">
                      <img src={icon8} />
                      <span>교재몰</span>
                    </div>
                  </Link>
                </li> */}
              </ul>
            </div>
            <div className="hd_right_menu_bottom">
              <ul>
                {" "}
                <li className="bottom_menu_li">
                  <Link to="/notice" onClick={() => menu_click()}>
                    <div className="bottom_menu_div">
                      <img src={icon9} />
                      <span>공지사항</span>
                    </div>
                  </Link>
                </li>{" "}
                <li className="bottom_menu_li">
                  <Link to="/qna" onClick={() => menu_click()}>
                    <div className="bottom_menu_div">
                      <img src={icon10} />
                      <span>자주묻는 질문</span>
                    </div>
                  </Link>
                </li>{" "}
                <li className="bottom_menu_li">
                  {/* <Link to="" id="custom-button-2"> */}
                  <div
                    className="bottom_menu_div"
                    id="custom-button-2"
                    style={{ cursor: "pointer" }}
                  >
                    <img src={icon11} />
                    <span>1:1 상담</span>
                  </div>
                  {/* </Link> */}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>{" "}
      <div className="header-wrap-bg">
        <div className="header-wrap">
          {" "}
          <div className="big_wrap">
            <div className="group">
              <div className="logo">
                <Link to="/" className="logo_anchor">
                  <img src={logo} alt="로고alt" />
                </Link>
              </div>
              {/* <div className="coin_box">
                <div className="coin_item">
                  <a href="#n" className="coin_btn">
                    <div>
                      <div className="conin_icon">ⓒ</div>
                      <span>12,000</span>
                    </div>
                  </a>
                </div>
                <div className="coin_item2">
                  <a href="#n" className="all_btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="54.822"
                      height="50"
                      viewBox="0 0 54.822 50"
                    >
                      <path
                        id="패스_1692"
                        data-name="패스 1692"
                        d="M598.576,50.136a9.894,9.894,0,0,0-5.821-9.017,9.9,9.9,0,0,0-13.047-11.068A9.9,9.9,0,0,0,562.478,30a9.892,9.892,0,0,0-12.9,11.116,9.9,9.9,0,0,0-.044,18.015A9.9,9.9,0,0,0,562.478,70a9.9,9.9,0,0,0,17.23-.048A9.9,9.9,0,0,0,592.8,59.134,9.9,9.9,0,0,0,598.576,50.136Z"
                        transform="translate(-543.754 -25)"
                        fill="#fff"
                      />
                    </svg>
                    <span>전체</span>
                  </a>
                </div>
              </div> */}
            </div>
            <div className="site_div">
              <nav className="site_nav1">
                <ul className="site_ul">
                  <li>
                    <Link to="/myclass">나의 학습방</Link>
                  </li>
                  <li>
                    <Link to="/month-lesson">이달의 학습방</Link>
                  </li>
                </ul>
              </nav>{" "}
              <div className="site_nav2">
                {/* <ul className="site_ul2">
                  <li>
                    <a href="#">
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24.893"
                          height="23.727"
                          viewBox="0 0 24.893 23.727"
                        >
                          <g
                            id="그룹_2214"
                            data-name="그룹 2214"
                            transform="translate(-1495.72 -38.137)"
                          >
                            <path
                              id="패스_1695"
                              data-name="패스 1695"
                              d="M1500.909,50.139a.709.709,0,0,0,.283-.468,7.363,7.363,0,0,1,4.485-6.028,6.859,6.859,0,0,1,6.176.613l-1.763,2.2a.714.714,0,0,0,.5,1.158l9.251.8a.715.715,0,0,0,.743-.927l-2.8-8.853a.715.715,0,0,0-1.239-.232l-1.8,2.248a11.47,11.47,0,0,0-10.737-1.3,11.851,11.851,0,0,0-7.363,9.623.712.712,0,0,0,.261.665.7.7,0,0,0,.338.148l3.138.479A.714.714,0,0,0,1500.909,50.139Z"
                              fill="#fff"
                            />
                            <path
                              id="패스_1696"
                              data-name="패스 1696"
                              d="M1519.692,51.023a.713.713,0,0,0-.6-.814l-3.138-.478a.713.713,0,0,0-.814.6,7.364,7.364,0,0,1-4.484,6.028,6.857,6.857,0,0,1-6.177-.613l1.763-2.2a.715.715,0,0,0-.5-1.159l-9.251-.8a.715.715,0,0,0-.743.927l2.8,8.853a.712.712,0,0,0,.234.343.715.715,0,0,0,1.005-.111l1.8-2.247a11.473,11.473,0,0,0,10.737,1.3A11.849,11.849,0,0,0,1519.692,51.023Z"
                              fill="#fff"
                            />
                          </g>
                        </svg>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26.753"
                          height="30"
                          viewBox="0 0 26.753 30"
                        >
                          <g
                            id="그룹_2216"
                            data-name="그룹 2216"
                            transform="translate(-1574.79 -34.589)"
                          >
                            <rect
                              id="사각형_1034"
                              data-name="사각형 1034"
                              width="22.345"
                              height="9.887"
                              transform="translate(1576.026 55.422) rotate(-48.725)"
                              fill="#fff"
                            />
                            <path
                              id="패스_1697"
                              data-name="패스 1697"
                              d="M1575.961,55.376l-1.171,9.213,8.684-2.618Zm.411,5.3.4-3.154,4.533,3.98-2.97.9Z"
                              fill="#fff"
                            />
                            <path
                              id="패스_1698"
                              data-name="패스 1698"
                              d="M1600.029,36.367l-.766-.672a4.449,4.449,0,0,0-6.278.408l-1.044,1.189,7.453,6.543,1.044-1.19A4.449,4.449,0,0,0,1600.029,36.367Z"
                              fill="#fff"
                            />
                          </g>
                        </svg>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="29.958"
                          viewBox="0 0 30 29.958"
                        >
                          <path
                            id="패스_1694"
                            data-name="패스 1694"
                            d="M1668.144,55.287A5.287,5.287,0,1,1,1673.431,50a5.3,5.3,0,0,1-5.287,5.287Zm11.895-8.591a11.552,11.552,0,0,0-1.146-2.731l1.1-3.305-2.511-2.511-3.3,1.1A12.716,12.716,0,0,0,1671.4,38.1l-1.5-3.084h-3.525l-1.541,3.084a11.551,11.551,0,0,0-2.732,1.146l-3.3-1.1-2.511,2.511,1.1,3.305a12.727,12.727,0,0,0-1.146,2.775l-3.083,1.5v3.524l3.083,1.542a11.562,11.562,0,0,0,1.146,2.731l-1.1,3.305,2.511,2.511,3.3-1.1a12.713,12.713,0,0,0,2.776,1.146l1.541,3.084h3.525l1.542-3.084a11.561,11.561,0,0,0,2.731-1.146l3.3,1.1,2.511-2.511-1.1-3.305a12.727,12.727,0,0,0,1.146-2.775l3.084-1.542V48.194l-3.128-1.5Z"
                            transform="translate(-1653.167 -35.021)"
                            fill="#fff"
                          />
                        </svg>
                      </div>
                    </a>
                  </li>
                </ul> */}
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    menu_click();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="54.822"
                    height="50"
                    viewBox="0 0 54.822 50"
                  >
                    <g
                      id="그룹_2209"
                      data-name="그룹 2209"
                      transform="translate(-1753.167 -25.317)"
                    >
                      <g
                        id="패스_1691"
                        data-name="패스 1691"
                        fill="#f5a21f"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          d="M 1780.491943359375 73.81700134277344 C 1777.484497070312 73.81700134277344 1774.688110351562 72.18993377685547 1773.19384765625 69.57073974609375 L 1772.581909179688 68.49787902832031 L 1771.411499023438 68.8927001953125 C 1770.54541015625 69.18486022949219 1769.642944335938 69.33300018310547 1768.72900390625 69.33300018310547 C 1764.098876953125 69.33300018310547 1760.33203125 65.56612396240234 1760.33203125 60.93600082397461 C 1760.33203125 60.5142822265625 1760.36376953125 60.08977127075195 1760.42626953125 59.67426300048828 L 1760.59423828125 58.55810165405273 L 1759.568359375 58.08756256103516 C 1758.126220703125 57.42613983154297 1756.9033203125 56.37311172485352 1756.031982421875 55.04231262207031 C 1755.139038085938 53.67855072021484 1754.6669921875 52.09160232543945 1754.6669921875 50.4530029296875 C 1754.6669921875 47.1633415222168 1756.605590820312 44.15993118286133 1759.605834960938 42.80145263671875 L 1760.667724609375 42.32062149047852 L 1760.463989257812 41.17287063598633 C 1760.37646484375 40.67956161499023 1760.33203125 40.18300247192383 1760.33203125 39.69700241088867 C 1760.33203125 35.0668830871582 1764.098876953125 31.30000114440918 1768.72900390625 31.30000114440918 C 1769.640991210938 31.30000114440918 1770.54345703125 31.4484806060791 1771.411499023438 31.74130058288574 L 1772.58203125 32.13618087768555 L 1773.193969726562 31.06307220458984 C 1774.687622070312 28.44400215148926 1777.484008789062 26.81700134277344 1780.491943359375 26.81700134277344 C 1783.520385742188 26.81700134277344 1786.325927734375 28.45952224731445 1787.813720703125 31.10357093811035 L 1788.432250976562 32.20294189453125 L 1789.621459960938 31.78204154968262 C 1790.525146484375 31.46218109130859 1791.469116210938 31.30000114440918 1792.427001953125 31.30000114440918 C 1797.05712890625 31.30000114440918 1800.823974609375 35.0668830871582 1800.823974609375 39.69700241088867 C 1800.823974609375 40.17873001098633 1800.779174804688 40.67539215087891 1800.691040039062 41.17320251464844 L 1800.487548828125 42.32073211669922 L 1801.549194335938 42.80145263671875 C 1804.550048828125 44.16020202636719 1806.489013671875 47.16361236572266 1806.489013671875 50.4530029296875 C 1806.489013671875 52.0914306640625 1806.016845703125 53.67834091186523 1805.123657226562 55.04217147827148 C 1804.252075195312 56.37298965454102 1803.029052734375 57.42607116699219 1801.586669921875 58.08756256103516 L 1800.560791015625 58.55810165405273 L 1800.728759765625 59.67426300048828 C 1800.7919921875 60.09408950805664 1800.823974609375 60.51860046386719 1800.823974609375 60.93600082397461 C 1800.823974609375 65.56612396240234 1797.05712890625 69.33300018310547 1792.427001953125 69.33300018310547 C 1791.466674804688 69.33300018310547 1790.523071289062 69.17095947265625 1789.622680664062 68.85139465332031 L 1788.4326171875 68.42903900146484 L 1787.813598632812 69.52960968017578 C 1786.326049804688 72.17417144775391 1783.5205078125 73.81700134277344 1780.491943359375 73.81700134277344 Z"
                          stroke="none"
                        />
                        <path
                          d="M 1780.491943359375 72.31700134277344 C 1782.9794921875 72.31700134277344 1785.283935546875 70.96714782714844 1786.506225585938 68.79422760009766 C 1787.221801757812 67.52226257324219 1788.748413085938 66.94949340820312 1790.124389648438 67.43778228759766 C 1790.86328125 67.70003509521484 1791.638061523438 67.83300018310547 1792.427001953125 67.83300018310547 C 1796.22998046875 67.83300018310547 1799.323974609375 64.73902130126953 1799.323974609375 60.93600082397461 C 1799.323974609375 60.59309005737305 1799.297607421875 60.24369049072266 1799.245483398438 59.89752197265625 C 1799.046508789062 58.57554244995117 1799.746215820312 57.28143310546875 1800.96142578125 56.7241096496582 C 1803.408081054688 55.60198974609375 1804.989013671875 53.14043045043945 1804.989013671875 50.4530029296875 C 1804.989013671875 47.75129318237305 1803.39599609375 45.28424072265625 1800.930541992188 44.16790008544922 C 1799.681396484375 43.60227203369141 1798.974731445312 42.26163101196289 1799.213989257812 40.91141128540039 C 1799.286987304688 40.49978256225586 1799.323974609375 40.09120178222656 1799.323974609375 39.69700241088867 C 1799.323974609375 35.89398193359375 1796.22998046875 32.80000305175781 1792.427001953125 32.80000305175781 C 1791.640014648438 32.80000305175781 1790.864501953125 32.93326187133789 1790.121948242188 33.19608306884766 C 1788.7470703125 33.68281555175781 1787.221557617188 33.11000061035156 1786.506469726562 31.83914184570312 C 1785.284057617188 29.66661071777344 1782.979370117188 28.31700134277344 1780.491943359375 28.31700134277344 C 1778.021484375 28.31700134277344 1775.724365234375 29.65396118164062 1774.4970703125 31.80615043640137 C 1773.7861328125 33.0528450012207 1772.291870117188 33.62126541137695 1770.932006835938 33.16261291503906 C 1770.218872070312 32.92200088500977 1769.477661132812 32.80000305175781 1768.72900390625 32.80000305175781 C 1764.926025390625 32.80000305175781 1761.83203125 35.89398193359375 1761.83203125 39.69700241088867 C 1761.83203125 40.09535980224609 1761.86865234375 40.50372314453125 1761.94091796875 40.91075134277344 C 1762.180541992188 42.26116180419922 1761.473876953125 43.6021728515625 1760.224487304688 44.16790008544922 C 1757.759643554688 45.28396987915039 1756.1669921875 47.75102233886719 1756.1669921875 50.4530029296875 C 1756.1669921875 53.14070129394531 1757.74755859375 55.60226058959961 1760.193603515625 56.7241096496582 C 1761.408813476562 57.28143310546875 1762.108520507812 58.57554244995117 1761.909545898438 59.89752197265625 C 1761.858154296875 60.23937225341797 1761.83203125 60.58877182006836 1761.83203125 60.93600082397461 C 1761.83203125 64.73902130126953 1764.926025390625 67.83300018310547 1768.72900390625 67.83300018310547 C 1769.479614257812 67.83300018310547 1770.220825195312 67.71134185791016 1770.932006835938 67.47138977050781 C 1772.292358398438 67.01273345947266 1773.785888671875 67.58110046386719 1774.496826171875 68.82748413085938 C 1775.724731445312 70.97988891601562 1778.021850585938 72.31700134277344 1780.491943359375 72.31700134277344 M 1780.491943359375 75.31700134277344 C 1776.807006835938 75.31700134277344 1773.594970703125 73.30100250244141 1771.890991210938 70.31400299072266 C 1770.89794921875 70.64900207519531 1769.8349609375 70.83300018310547 1768.72900390625 70.83300018310547 C 1763.262939453125 70.83300018310547 1758.83203125 66.40200042724609 1758.83203125 60.93600082397461 C 1758.83203125 60.43200302124023 1758.869995117188 59.93600082397461 1758.942993164062 59.45100021362305 C 1755.535034179688 57.88800048828125 1753.1669921875 54.44800186157227 1753.1669921875 50.4530029296875 C 1753.1669921875 46.44100189208984 1755.555053710938 42.9890022277832 1758.987060546875 41.43500137329102 C 1758.886962890625 40.87100219726562 1758.83203125 40.29100036621094 1758.83203125 39.69700241088867 C 1758.83203125 34.23100280761719 1763.262939453125 29.80000114440918 1768.72900390625 29.80000114440918 C 1769.8349609375 29.80000114440918 1770.89794921875 29.98500061035156 1771.890991210938 30.32000160217285 C 1773.594970703125 27.33200073242188 1776.807006835938 25.31700134277344 1780.491943359375 25.31700134277344 C 1784.197021484375 25.31700134277344 1787.425048828125 27.35400199890137 1789.120971679688 30.36800193786621 C 1790.155029296875 30.00200080871582 1791.266967773438 29.80000114440918 1792.427001953125 29.80000114440918 C 1797.892944335938 29.80000114440918 1802.323974609375 34.23100280761719 1802.323974609375 39.69700241088867 C 1802.323974609375 40.29100036621094 1802.267944335938 40.87100219726562 1802.16796875 41.43500137329102 C 1805.599975585938 42.9890022277832 1807.989013671875 46.44100189208984 1807.989013671875 50.4530029296875 C 1807.989013671875 54.44800186157227 1805.619995117188 57.88800048828125 1802.212036132812 59.45100021362305 C 1802.285034179688 59.93600082397461 1802.323974609375 60.43200302124023 1802.323974609375 60.93600082397461 C 1802.323974609375 66.40200042724609 1797.892944335938 70.83300018310547 1792.427001953125 70.83300018310547 C 1791.266967773438 70.83300018310547 1790.155029296875 70.63200378417969 1789.120971679688 70.26499938964844 C 1787.425048828125 73.27999877929688 1784.197021484375 75.31700134277344 1780.491943359375 75.31700134277344 Z"
                          stroke="none"
                          fill="#fff"
                        />
                      </g>
                      <g id="그룹_2208" data-name="그룹 2208">
                        <rect
                          id="사각형_1027"
                          data-name="사각형 1027"
                          width="24"
                          height="4.889"
                          transform="translate(1768.578 40.317)"
                          fill="#fff"
                        />
                        <rect
                          id="사각형_1028"
                          data-name="사각형 1028"
                          width="24"
                          height="4.889"
                          transform="translate(1768.578 47.872)"
                          fill="#fff"
                        />
                        <rect
                          id="사각형_1029"
                          data-name="사각형 1029"
                          width="24"
                          height="4.889"
                          transform="translate(1768.578 55.428)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Header;
